import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { Checkbox } from '../../../../../../../../CommonComponents/OPL/Checkbox/Checkbox';
import { FormFields } from '../../AccountForm.meta';
import { isConsumerArea } from '../../../../../../../../CommonSelectors/CommonAreaSelector';

export const BrokerOfRecord = () => {
  const isConsumer = useSelector(isConsumerArea);
  if (isConsumer) {
    return null;
  }

  return <BrokerOfRecordContent />;
};

const BrokerOfRecordContent = () => {
  const formBag = useFormContext<FormFields>();

  const { register, setValue, watch } = formBag;

  const isBrokerOfRecordValue = watch('bankAccount.IsBrokerOfRecord');
  const [initialValue] = useState(isBrokerOfRecordValue);

  const isBrokerOfRecordRegistry = register('bankAccount.IsBrokerOfRecord');
  return (
    <Checkbox
      {...isBrokerOfRecordRegistry}
      onChange={evt => {
        isBrokerOfRecordRegistry.onChange(evt);

        if (initialValue !== evt.target.checked) {
          setValue('bankAccount.HasAdvisorChangedBrokerOfRecord', true);
        } else {
          setValue('bankAccount.HasAdvisorChangedBrokerOfRecord', false);
        }
      }}
    >
      I&apos;m the broker of record for this account
    </Checkbox>
  );
};
